import { Paper } from '@mui/material'
import { Bell } from '../atoms'

const Notification = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        padding: '22px 16px 16px',
        borderRadius: '15px',
        fontFamily: `'__golosTextVF_099e87', '__golosTextVF_Fallback_099e87', sans-serif`,
        fontWeight: 400,
        lineHeight: '120%',
        fontSize: '12px',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
        '@media (max-width: 1280px)': {
          padding: '18px 12px 12px'
        },
        '@media (max-width: 768px)': {
          fontSize: '10px'
        },
        '@media (max-width: 480px)': {
          padding: '18px 11px 9px'
        }
      }}>
      <Bell
        sx={{
          position: 'absolute',
          top: '-12px',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      />
      <span>В Telegram- чате можно общаться</span>
      <br />
      <span>
        с менторами и другими участниками, задавать вопросы, обсуждать задания
      </span>
    </Paper>
  )
}

export default Notification
